export const formatMoney = (moneyString) => {
    const formattedNumber = Number(moneyString).toFixed(2);
    const outputMoney = `$${formattedNumber}`;
    return outputMoney;
};
